<template>
  <div>
    <el-dialog
      :title="couponInfo.title + '生成记录'"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      width="80%"
    >
      <!--search from-->
      <el-form
        ref="formRef"
        :inline="true"
        size="mini"
        :rules="formRules"
        :model="searchForm"
        class="demo-form-inline"
      >
        <el-form-item label="是否领取">
          <el-select
            v-model="searchForm.state"
            placeholder="请选择"
            clearable
            size="mini"
          >
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="searchForm.beginTime"
            type="date"
            placeholder="选择日期"
            style="width:150px"
            size="mini"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          ~
          <el-date-picker
            v-model="searchForm.endTime"
            type="date"
            placeholder="选择日期"
            style="width:150px"
            size="mini"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="loadPage(1)"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <!--btn-->
      <div class="btn">
        <el-button
          type="success"
          size="mini"
          icon="el-icon-plus"
          @click="showGenerate"
          >生成</el-button
        >
      </div>
      <!--table-->
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        size="mini"
      >
        <!--index-->
        <el-table-column
          type="index"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="couponCode"
          label="优惠券码"
          align="center"
        ></el-table-column>
        <el-table-column prop="state" label="是否领取" align="center">
          <template slot-scope="scope">
            {{ scope.row.state | stateFilter }}
          </template>
        </el-table-column>
        <el-table-column
          prop="created"
          label="创建时间"
          align="center"
        ></el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchForm.total"
        size="mini"
      >
      </el-pagination>
    </el-dialog>

    <!--dialog-->
    <el-dialog
      title="生成"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleGenerateClose"
      width="30%"
      center
      v-loading="generateLoading"
    >
      <el-form :inline="true" size="mini" class="demo-form-inline">
        <el-form-item label="生成数量">
          <el-input-number v-model="generateNum" :min="1"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="handleGenerate"
          >生成</el-button
        >
        <el-button size="mini" @click="handleGenerateClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { loadCouponCodePageApi, generateCouponCodeApi } from "@/api/coupon";
export default {
  name: "generateCoupon",
  filters: {
    stateFilter(type) {
      if (type == 0) {
        return "未领取";
      }
      if (type == 1) {
        return "已领取";
      }
      return type;
    }
  },
  data() {
    return {
      generateLoading: false,
      dialogVisible: false,
      visible: false,
      generateNum: 1,
      couponInfo: {},
      stateOptions: [
        {
          label: "未领取",
          value: 0
        },
        {
          label: "已领取",
          value: 1
        }
      ],
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      formRules: {
        createTime: [
          {
            validator: (rule, value, callback) => {
              if (
                this.searchForm.beginTime &&
                this.searchForm.endTime &&
                this.searchForm.beginTime.getTime() >
                  this.searchForm.endTime.getTime()
              ) {
                callback(new Error("结束时间必须大于开始时间"));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      },
      loading: false,
      tableData: []
    };
  },
  methods: {
    open(row) {
      this.couponInfo = row;
      this.visible = true;
      setTimeout(() => {
        this.loadPage(1);
      }, 100);
    },
    handleClose() {
      this.visible = false;
      this.$emit("close");
      this.couponInfo = {};
      this.tableData = [];
    },
    loadPage(num) {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          if (num) {
            this.searchForm.pageNum = num;
          }
          this._loadPage();
        }
      });
    },
    _loadPage() {
      this.loading = true;
      this.searchForm.couponId=this.couponInfo.id;
      loadCouponCodePageApi(this.searchForm)
        .then(resp => {
          if (resp.data.status == 100) {
            this.tableData = resp.data.results.list;
            this.searchForm.total = resp.data.results.total;
          } else {
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPage();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.loadPage();
    },
    showGenerate() {
      this.dialogVisible = true;
      this.generateNum = 1;
    },
    handleGenerateClose() {
      this.dialogVisible = false;
      this.generateNum = 1;
      this.loadPage(1);
    },
    handleGenerate() {
      if (this.generateNum <= 0) {
        this.$message({
          message: "生成数量必须大于0",
          type: "error"
        });
        return;
      }
      this._generateCouponCode();
    },
    _generateCouponCode() {
      if (this.generateNum <= 0) {
        return;
      }
      if (this.couponInfo == null || this.couponInfo.id == null) {
        return;
      }
      this.generateLoading = true;
      generateCouponCodeApi(this.couponInfo.id, this.generateNum)
        .then(resp => {
          if (resp.data.status == 100) {
            this.$message({
              message: resp.data.message,
              type: "success"
            });
            setTimeout(() => {
              this.handleGenerateClose();
            }, 100);
          } else {
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.generateLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.btn {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// generateCoupon.vue?bd2c73be